// @flow
import React, {useEffect, useRef} from "react";
import type {Captcha} from "../models/Captcha";
import "./SlCaptcha.scss";
import NotificationApi from "../api/NotificationApi";

export type SlCaptchaProps = {
	setCaptcha: Captcha => void,
	captcha: Captcha,
	error: boolean,
	// told once the captcha could not be loaded (limit hit, backend down); the form hides itself then (#56604)
	setUnavailable?: boolean => void,
};

const SlCaptcha = ({captcha, error, setCaptcha, setUnavailable}: SlCaptchaProps) => {
	const loadedOnce = useRef(false);

	// loads on mount and whenever a failure is raised - not again when the failure flag
	// is reset, that second load used to burn a challenge for nothing (#56604)
	useEffect(() => {
		if (loadedOnce.current && !error) {
			return;
		}
		loadedOnce.current = true;
		const api = new NotificationApi();
		api.getCaptcha()
			.then(it => setCaptcha(it))
			.catch(() => setUnavailable && setUnavailable(true));
	}, [error, setCaptcha, setUnavailable]);

	return captcha
		? <div className={"slCaptcha"}>
			<div className={"captchaInput"}>
				<input type={"text"} placeholder={"Captcha"} required={true}
					   value={captcha.captchaSolution.replace(" ", "").toLowerCase()}
					   onChange={e => setCaptcha({...(captcha), captchaSolution: e.target.value})}
					   onKeyDown={e => {
						   if (e.key === "Enter") {
							   e.preventDefault();
							   e.stopPropagation();
						   }
					   }}/>
			</div>
			<div className={"captchaImage"}>
				<img src={captcha.base64} alt={"Captcha"}/>
			</div>
		</div>
		: <div/>;
};

export default SlCaptcha;
